import { Padrao } from '../generic/padrao';

export class PessoaRegra extends Padrao{

    override idTab = 238;

    descricao: string;
}